import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import TextArea from '../../widgets/TextArea';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';
import Specialization from '../../widgets/Specialization';


export function EditProviderPackages() {
    const [state, setState] = useState({provider:null, errors:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getprovider();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getprovider = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/`, config);
            showLoading(dispatch, false);
            // console.log(reply.data.dateOfBirth);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(!reply.data.packages?.length > 0) {
                    reply.data.packages = [{}]
                }

                setState({
                    ...state,
                    provider: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {packages: state.provider.packages};

            try {
                const reply = await axios.patch(API_URL + '/provider', data, config);
                showLoading(dispatch, false);
                //console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    //navigateTo(dispatch, navigate, "/provider");
                    navigateTo(dispatch, navigate, -1);
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changePackage = (index, e) => {
        state.provider.packages[index][e.target.id] = e.target.value;
        change('packages',state.provider.packages);
    };

    const addError = (errors, index, name, error) => {
        if(!errors.packages) {
            errors.packages = [];
        }
        while(!errors.packages[index]) {
            errors.packages.push({});
        }
        errors.packages[index][name] = error;
    }

    const validateForm = () => {
        const errors = {};
        for (let index = 0; index < state.provider.packages.length; index++) {
            if (!state.provider.packages?.[index]?.name?.trim()) {
                addError(errors, index, 'name', 'the_name_of_package_that_you_offer_error');
            }
            if (!state.provider.packages?.[index]?.description?.trim()) {
                addError(errors, index, 'description', 'details_about_the_package_error');
            }
            if (!state.provider.packages?.[index]?.quantity?.trim()) {
                addError(errors, index, 'quantity', 'quantity_that_you_offer_error');
            }
            if (!state.provider.packages?.[index]?.price?.trim()) {
                addError(errors, index, 'price', 'price_of_the_package_error');
            }
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    const addPackage = (e) => {
        if(state.provider.packages?.length < 3) {
            state.provider.packages.push({});
            change('packages',state.provider.packages);
        }
    };

    const removePackage = (index) => {
        if(state.provider.packages?.length > 1) {
            state.provider.packages.splice(index, 1);
            change('packages',state.provider.packages);
        }

    };


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background showClouds={true} >
                            <div className='right-main-inner'>
                                <div className='mt40'>
                                    <div className='center-div font-25 font-bold text-align-center'>{t("add_packages")}</div>
                                </div>

                                <div className='mt30'>
                                    <div className='center-div font-20 text-align-center'>{t("add_up_to_three_packages")}</div>
                                </div>

                                {state.provider.packages && state.provider.packages.map((item, key) => (
                                    <div key={key}>
                                        <div className='mt30'>
                                            <Input className={state.errors.packages?.[key]?.name?"error":""} id="name" placeholder={t("the_name_of_package_that_you_offer")} value={item.name??''} onChange={(e) => changePackage(key, e)}/>
                                        </div>
                                        {state.errors.packages?.[key]?.name && <div className='mt5 error font-12'><Trans i18nKey={state.errors.packages?.[key]?.name} /></div>}

                                        <div className='mt30'>
                                            <TextArea className={state.errors.packages?.[key]?.description?"error":""} id="description" placeholder={t("details_about_the_package")} footer={t('up_to_500_words')} value={item.description??''} onChange={(e) => changePackage(key, e)}/>
                                        </div>
                                        {state.errors.packages?.[key]?.description && <div className='mt5 error font-12'><Trans i18nKey={state.errors.packages?.[key]?.description} /></div>}

                                        <div className='mt30'>
                                            <Input className={state.errors.packages?.[key]?.quantity?"error":""} id="quantity" placeholder={t("quantity_that_you_offer")} value={item.quantity??''} onChange={(e) => changePackage(key, e)}/>
                                        </div>
                                        {state.errors.packages?.[key]?.quantity && <div className='mt5 error font-12'><Trans i18nKey={state.errors.packages?.[key]?.quantity} /></div>}

                                        <div className='mt10'>
                                            <div className='font-12'>{t("package_quantity_examples")}</div>
                                        </div>

                                        <div className='mt30'>
                                            <Input className={state.errors.packages?.[key]?.price?"error":""} id="price" placeholder={t("price_of_the_package")} value={item.price??''} onChange={(e) => changePackage(key, e)}/>
                                        </div>
                                        {state.errors.packages?.[key]?.price && <div className='mt5 error font-12'><Trans i18nKey={state.errors.packages?.[key]?.price} /></div>}

                                        <div className='mt10'>
                                            <div className='font-12'>{t("package_price_explanation")}</div>
                                        </div>
                                        {/* {state.errors.packages?.[key] && Object.entries(state.errors.packages[key]).map(([key, msg]) => (
                                            <h2 key={key} className='mt10 error'><Trans i18nKey={msg} /></h2>
                                        ))} */}
                                        {state.provider.packages?.length > 1 && <div className='center-div align-items-center mt20 mb60'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => removePackage(key)}>  <div className='mb5'>{t("-")}</div> </div></div>}
                                    </div>
                                 ))}

                                {state.provider.packages?.length < 3 && <div className='center-div align-items-center mt20'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => addPackage()}>  <div>{t("+")}</div> </div></div>}
                                <div className='button-form font-18 color-550952 mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("save")}</div> </div>
                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}